<template>
  <div id="app">
    <div id="nav">
      <router-link to="/">Home</router-link>
      <!-- <router-link to="/dev">Dev</router-link> -->
      <!-- <router-link to="/quote">Quote</router-link> -->
    </div>
    <router-view/>
    <vue-canvas-nest :config="{ color: '102,102,102', opacity: 0.6, zIndex: -2, count: 102 }"></vue-canvas-nest>
  </div>
</template>

<script>
import vueCanvasNest from 'vue-canvas-nest'
export default {
    components: { vueCanvasNest }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #42b983;
  text-decoration: none;
}

#nav a.router-link-exact-active {
  color: #2c3e50;
}
</style>
